import { render } from "./Map.vue?vue&type=template&id=0a2581f3&ts=true"
import script from "./Map.vue?vue&type=script&lang=ts"
export * from "./Map.vue?vue&type=script&lang=ts"

import "./Map.vue?vue&type=style&index=0&id=0a2581f3&lang=css"

import exportComponent from "/home/runner/work/tc-admin/tc-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__